<template>
    <div>
        <hero-bar :has-right-visible="true" menu-icon="desktop-mac">
            {{ $lang.PanelInfos.Title_2 }}
            <span class="subtitle hero-subtitle">{{ $lang.Menus.FillFields }}</span>

            <p class="control" slot="right" style="margin-right: 16px">
                <b-button class="button is-gray" @click="previous">{{ $lang.Menus.BackBtn }}</b-button>
            </p>
            <p class="control" slot="right">
                <b-button v-if="isAeCalculated" class="button is-primary" @click="submit">{{ $lang.Menus.ContinueBtn }}</b-button>
                <b-button v-else class="button is-primary" @click="getAeValue_3">{{ $lang.PanelInfos.CalculateBtn }}</b-button>
            </p>
        </hero-bar>

        <div class="wizard">
            <div class="wizard-rail">
                <verticalStep-bar />
            </div>

            <div class="wizard-body">
                <div class="wizard-aside-layout">
                    <div class="wizard-body">
                        <!-- One labelled row per input; every @input chain is the one it had. -->
                        <div class="wizard-card">
                            <b-field class="form-row" :label="$lang.PanelInfos.PanelType" :type="{ 'is-danger': hasError_panelType }" :message="emptyWarning_panelType">
                                <div class="choice-inline">
                                    <div v-for="(option, index) in paneltypelist.slice(0, 2)" :key="'type' + index" class="choice-row" :class="{ 'is-selected': panelTypeRadio == 'value_' + (index + 1) }">
                                        <b-radio v-model="panelTypeRadio" :native-value="'value_' + (index + 1)" @input="onPanelTypeChanged(); enableManuelSave();">
                                            {{ option }}
                                        </b-radio>
                                    </div>
                                </div>
                            </b-field>

                            <b-field class="form-row" :label="$lang.PanelInfos.PanelIP" :type="{ 'is-danger': hasError_ip }" :message="emptyWarning_ip">
                                <div class="choice-inline">
                                    <div v-for="(option, index) in paneliplist.slice(0, 2)" :key="'ip' + index" class="choice-row" :class="{ 'is-selected': panelIpRadio == 'value_' + (index + 1) }">
                                        <b-radio v-model="panelIpRadio" :native-value="'value_' + (index + 1)" @input="onPanelIpChanged(); enableManuelSave();">
                                            {{ option }}
                                        </b-radio>
                                    </div>
                                </div>
                            </b-field>

                            <b-field class="form-row" :label="$lang.PanelInfos.PanelDimension" :type="{ 'is-danger': hasError_panelDimensions }" :message="emptyWarning_panelDimensions">
                                <b-select v-if="paneldimensionslist" v-model="panelDimension" class="form-select" @input="getS_airValue(); enableManuelSave();">
                                    <option v-for="option in paneldimensionslist" :value="option" :key="option">
                                        {{ option }}
                                    </option>
                                </b-select>
                            </b-field>

                            <!-- Placement: a b-radio per card, the picture above its name, the ring in the corner. -->
                            <b-field class="form-row" :label="$lang.PanelInfos.PanelSurface" :type="{ 'is-danger': hasError_virtualSurface }" :message="emptyWarning_virtualSurface">
                                <div class="surface-grid">
                                    <b-radio v-for="(surface, index) in virtualsurfaces.slice(0, virtualsurfaces.length > 3 ? 6 : 3)"
                                             :key="'surface' + index"
                                             v-model="virtualSurface"
                                             class="surface-card"
                                             :class="{ 'is-selected': virtualSurface == 'value_' + (index + 1) }"
                                             :native-value="'value_' + (index + 1)"
                                             @input="onSurfaceChanged(); enableManuelSave();">
                                        <img class="surface-image"
                                             :src="'/img/PanelLocations/' + (virtualsurfaces.length > 3 ? 'DikiliTip_' : 'DuvarTipi_') + (index + 1) + '.png'"
                                             alt="" />
                                        <span class="surface-name">{{ surface }}</span>
                                    </b-radio>
                                </div>
                            </b-field>

                            <b-field v-if="Sair != 'N/A'" class="form-row">
                                <template #label>
                                    <span v-html="$lang.PanelInfos.Sair"></span>
                                </template>
                                <b-input v-model="Sair" class="form-short" @input="setAeNotCalculated(); enableManuelSave();"></b-input>
                            </b-field>

                            <b-field v-if="seperationnumbers.length != 1" class="form-row" :label="$lang.PanelInfos.SeperationNumber">
                                <div class="choice-inline">
                                    <div v-for="(option, index) in seperationnumbers.slice(0, 6)" :key="'sep' + index" class="choice-row" :class="{ 'is-selected': seperationNumber == String(index) }">
                                        <b-radio v-model="seperationNumber" :native-value="String(index)" @input="setAeNotCalculated(); enableManuelSave();">
                                            {{ option }}
                                        </b-radio>
                                    </div>
                                </div>
                            </b-field>
                        </div>

                        <div class="wizard-notes">
                            <p class="wizard-notes-title">{{ $lang.PanelInfos.Info_3 }}</p>
                            <p>{{ $lang.PanelInfos.Info_4 }}</p>
                            <ul class="panelList1">
                                <li class="panelListItem1"> {{ $lang.PanelInfos.Info_5 }} </li>
                                <li class="panelListItem1"> {{ $lang.PanelInfos.Info_6 }} </li>
                                <li class="panelListItem1"> {{ $lang.PanelInfos.Info_7 }} </li>
                                <li class="panelListItem1"> {{ $lang.PanelInfos.Info_8 }} </li>
                                <li class="panelListItem1">
                                    {{ $lang.PanelInfos.Info_9 }}
                                    <ul class="panelList2">
                                        <li class="panelListItem2">{{ $lang.PanelInfos.Info_10 }}</li>
                                        <li class="panelListItem2">{{ $lang.PanelInfos.Info_11 }}</li>
                                        <li class="panelListItem2">{{ $lang.PanelInfos.Info_12 }}</li>
                                        <li class="panelListItem2">{{ $lang.PanelInfos.Info_13 }}</li>
                                    </ul>
                                </li>
                                <li class="panelListItem1"> {{ $lang.PanelInfos.Info_14 }} </li>
                                <li class="panelListItem1"> {{ $lang.PanelInfos.Info_15 }} </li>
                            </ul>
                        </div>
                    </div>

                    <!-- Ae: the total in brand blue, then the five surfaces. -->
                    <div class="ae-card">
                        <div class="ae-total">
                            <span class="ae-total-label">{{ $lang.PanelInfos.Ae_total }}</span>
                            <span class="ae-total-value">{{ total_Ae_field }}</span>
                        </div>
                        <div class="ae-row"><span>{{ $lang.PanelInfos.Ae_up }}</span><b>{{ ae_value_field_up }}</b></div>
                        <div class="ae-row"><span>{{ $lang.PanelInfos.Ae_front }}</span><b>{{ ae_value_field_front }}</b></div>
                        <div class="ae-row"><span>{{ $lang.PanelInfos.Ae_back }}</span><b>{{ ae_value_field_back }}</b></div>
                        <div class="ae-row"><span>{{ $lang.PanelInfos.Ae_left }}</span><b>{{ ae_value_field_left }}</b></div>
                        <div class="ae-row"><span>{{ $lang.PanelInfos.Ae_right }}</span><b>{{ ae_value_field_right }}</b></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import router from '@/router';
    import api from '@/api';
    import { toIpStandart, toCurrentLabel } from '@/constants/protectionClass';
    import VerticalStepBar from '@/components/VerticalStepBar.vue';

    const paneltypelist = [];
    const panelType = '';
    const paneldimensionslist = [];
    const panelDimension = '';
    const paneliplist = [];
    const panelIP = '';
    const Sair = '';
    const virtualsurfaces = [];
    const virtualsurfaceoptions = [];
    const virtualSurfaceOption = 0;
    const seperationnumbers = [];
    const seperationNumber = 0;

    export default {
        name: 'PanelInfos',
        components: {
            VerticalStepBar,
        },
        data() {
            return {
                isActive: true,
                isInfoOpened: false,
                label_panelType: this.$lang.PanelInfos.PanelType,
                label_panelDimension: this.$lang.PanelInfos.PanelDimension,
                label_panelIP: this.$lang.PanelInfos.PanelIP,
                label_virtualSurface: this.$lang.PanelInfos.PanelSurface,
                label_Sair: this.$lang.PanelInfos.Sair,
                label_virtualSurfaceOption: this.$lang.PanelInfos.VirtualSurface,
                label_seperationNumber: this.$lang.PanelInfos.SeperationNumber,
                label_total_Ae: this.$lang.PanelInfos.Ae_total,
                paneltypelist,
                panelType,
                panelTypeRadio: 'value_1',
                panelTypeRadioList: ['value_1', 'value_2'],
                panelTypeIndex: 0,
                paneldimensionslist,
                panelDimension,
                ip_Id: 0,
                paneliplist,
                panelIP,
                panelIpRadio: 'value_1',
                panelIpRadioList: ['value_1', 'value_2'],
                Sair,
                surfaceId: 0,
                surfaceId_2: 0,
                virtualsurfaces,
                virtualSurface: 'value_1',
                radios_surface: ['value_1', 'value_2', 'value_3', 'value_4', 'value_5', 'value_6', 'value_7'],
                virtualsurfaceoptions,
                virtualSurfaceOption,
                seperationnumbers,
                seperationNumber,
                total_Ae: 0,
                ae_values: [],
                ae_value_field_up: '',
                ae_value_field_front: '',
                ae_value_field_back: '',
                ae_value_field_left: '',
                ae_value_field_right: '',
                total_Ae_field: '',
                isAeCalculated: false,
                canGoNextPage: false,
                hasError_panelType: false,
                emptyWarning_panelType: '',
                hasError_panelDimensions: false,
                emptyWarning_panelDimensions: '',
                hasError_ip: false,
                emptyWarning_ip: '',
                hasError_virtualSurface: false,
                emptyWarning_virtualSurface: ''
            }
        },
        mounted() {
            this.getPanelTypes();
            this.getPanelDimensions();
            this.getPanelProtectionClassOptions();
            this.getLocationVirtualSurfaceOptions();
            this.getLocationVirtualSurfaceOptions_2();
            this.getHorizontalSeperationNumbers();

            if (this.$store.state.panelDimension != null && this.$store.state.panelDimension != '') {
                this.getAeValue_2();
            }

            this.virtualSurfaceOption = this.$store.state.virtualSurfaceOption;
            this.surfaceId_2 = this.$store.state.virtualSurfaceIndex;
            if (this.panelTypeIndex == 0) {
                this.surfaceId = this.surfaceId_2;
            } else {
                if (this.surfaceId_2 < 6) {
                    this.surfaceId = this.surfaceId_2 / 2;
                } else {
                    this.surfaceId = 7;
                }
            }

            this.$store.state.activeStep = 1;
            this.$store.state.isFooterFixed = true;
        },
        methods: {
            previous() {
                this.$store.isPageOpenedFromStepBar = false;

                router.push('/projectInfos');
            },
            submit() {
                this.controlInputs();

                if (this.canGoNextPage) {
                    // Ae is an input to the heat calculation. The next step used to follow a
                    // fixed 1000 ms after the request, whether or not Ae had arrived; it now
                    // follows the answer, and a failed lookup stays on this page.
                    // Always from what is on screen: a saved project used to be looked up from
                    // the store, whose dimension a change of IP had cleared - an empty lookup
                    // and "Ae could not be retrieved" although the screen showed Ae.
                    this.getAeValue().then((ok) => {
                        if (ok) {
                            this.nextPageFunc();
                        }
                    });
                }
            },
            enableManuelSave() {
                this.$store.state.canManuelSave = true;
            },
            setSavePayload() {
                var surfaceInfo = '';
                surfaceInfo = this.virtualsurfaces[this.surfaceId - 1];
                var ip = this.paneliplist.indexOf(this.panelIP);
                if (ip == -1) {
                    ip = 0;
                }
                ip += 1;
                this.ip_Id = ip;

                var payload = {
                    panelType: this.panelType, panelTypeIndex: this.panelTypeIndex, panelDimension: this.panelDimension, panelIP: this.panelIP, selectedIP_Id: this.ip_Id, Sair: this.Sair, surfaceExplanation: surfaceInfo, virtualSurface: this.virtualSurface, virtualSurfaceIndex: this.surfaceId_2, virtualSurfaceOption: this.virtualSurfaceOption, seperationNumber: this.seperationNumber, ae_value: this.total_Ae, ae_valueList: this.ae_values
                };
                this.$store.commit('setPanelInfos', payload);
            },
            nextPageFunc() {
                var surfaceInfo = '';
                surfaceInfo = this.virtualsurfaces[this.surfaceId - 1];
                var ip = this.paneliplist.indexOf(this.panelIP);
                if (ip == -1) {
                    ip = 0;
                }
                ip += 1;
                this.ip_Id = ip;

                var payload = {
                    panelType: this.panelType, panelTypeIndex: this.panelTypeIndex, panelDimension: this.panelDimension, panelIP: this.panelIP, selectedIP_Id: this.ip_Id, Sair: this.Sair, surfaceExplanation: surfaceInfo, virtualSurface: this.virtualSurface, virtualSurfaceIndex: this.surfaceId_2, virtualSurfaceOption: this.virtualSurfaceOption, seperationNumber: this.seperationNumber, ae_value: this.total_Ae, ae_valueList: this.ae_values
                };
                this.$store.commit('setPanelInfos', payload);

                this.$store.isPageOpenedFromStepBar = false;
                this.$store.canEnvConditionsOpen = true;

                router.push('/envConditions');
            },
            /*
             * A value is cleared when the list it was chosen from is replaced - and only when
             * the user changes something. The option loaders restore each value from the store
             * so a saved project reopens as it was; that is why the old resetFields calls
             * inside those loaders were commented out (they would have wiped a project on
             * open), and why clearing here covers the store as well: otherwise the loader
             * that follows puts the old, now invalid value straight back.
             */
            clearDependents(fields) {
                const store = this.$store.state;
                if (fields.includes('ip')) {
                    this.panelIP = '';
                    this.panelIpRadio = '';
                    store.panelIP = '';
                }
                if (fields.includes('dimension')) {
                    this.panelDimension = '';
                    this.Sair = 0;
                    store.panelDimension = '';
                }
                if (fields.includes('surface')) {
                    this.virtualSurface = '';
                    store.virtualSurface = '';
                }
                if (fields.includes('surface') || fields.includes('surfaceOption')) {
                    this.virtualSurfaceOption = 0;
                    store.virtualSurfaceOption = 0;
                }
                this.isAeCalculated = false;
            },
            // A new panel type brings new IP, dimension and placement lists.
            onPanelTypeChanged() {
                this.clearDependents(['ip', 'dimension', 'surface']);
                this.updateAll();
            },
            // A new IP class brings a new dimension list.
            onPanelIpChanged() {
                this.clearDependents(['dimension']);
                this.getPanelDimensions();
            },
            // A new placement brings its own surface options.
            onSurfaceChanged() {
                this.clearDependents(['surfaceOption']);
                this.getLocationVirtualSurfaceOptions_2();
            },
            controlInputs() {
                if (this.panelType == '') {
                    this.hasError_panelType = true;
                    this.emptyWarning_panelType = this.$lang.Menus.EmptyWarning;
                } else if (this.panelIP == '') {
                    this.hasError_ip = true;
                    this.emptyWarning_ip = this.$lang.Menus.EmptyWarning;
                } else if (this.panelDimension == '') {
                    this.hasError_panelDimensions = true;
                    this.emptyWarning_panelDimensions = this.$lang.Menus.EmptyWarning;
                } else if (this.virtualSurface == '' || this.virtualSurface == null || this.virtualSurface == 0) {
                    this.hasError_virtualSurface = true;
                    this.emptyWarning_virtualSurface = this.$lang.Menus.EmptyWarning;
                } else {
                    this.canGoNextPage = true;
                }

                if (this.panelType != '') {
                    this.hasError_panelType = false;
                    this.emptyWarning_panelType = '';
                }
                if (this.panelIP != '') {
                    this.hasError_ip = false;
                    this.emptyWarning_ip = '';
                }
                if (this.panelDimension != '') {
                    this.hasError_panelDimensions = false;
                    this.emptyWarning_panelDimensions = '';
                }
                if (this.virtualSurface != '' && this.virtualSurface != null && this.virtualSurface != 0) {
                    this.hasError_virtualSurface = false;
                    this.emptyWarning_virtualSurface = '';
                }
            },
            updateAll() {
                this.isAeCalculated = false;
                this.panelTypeIndex = this.panelTypeRadioList.indexOf(this.panelTypeRadio);
                this.panelType = this.paneltypelist[this.panelTypeIndex];
                if (this.panelTypeIndex == -1) {
                    this.panelTypeIndex = 0;
                }
                this.$store.state.panelTypeIndex = this.panelTypeIndex;
                this.getPanelDimensions();
                this.getPanelProtectionClassOptions();
                this.getLocationVirtualSurfaceOptions();
            },
            getPanelTypes() {
                this.paneltypelist = [];
                api.panels.getPanelTypes(this.$store.state.ratedCurrentIndex, this.$lang.Format.Lang).then((res) => {
                    if (res.isError) {
                        console.log("error ");
                    } else {
                        res.data.forEach((e) => {
                            this.paneltypelist.push(e.TypeName);
                        });
                        this.panelType = this.$store.state.panelType;

                        this.panelTypeIndex = this.$store.state.panelTypeIndex;
                        this.panelTypeRadio = this.panelTypeRadioList[this.panelTypeIndex];
                        this.panelType = this.paneltypelist[this.panelTypeIndex];
                    }
                });
            },

            getIp() {
                var i = this.panelIpRadioList.indexOf(this.panelIpRadio);
                this.panelIP = this.paneliplist[i];

                // Prefer the label held by this screen; fall back to the persisted one.
                var label = this.panelIP == '' ? this.$store.state.panelIP : this.panelIP;
                return toIpStandart(label);
            },
            getPanelProtectionClassOptions() {
                this.paneliplist = [];
                api.panels.getPanelProtectionClassOptions(this.$store.state.panelTypeIndex).then((res) => {
                    if (res.isError) {
                        console.log("error ");
                    } else {
                        res.data.forEach((e) => {
                            this.paneliplist.push(e.Option);
                        });
                        // A label persisted under the old name (localStorage) still ticks its class.
                        this.panelIP = toCurrentLabel(this.$store.state.panelIP);
                        this.panelIpRadio = this.panelIpRadioList[this.paneliplist.indexOf(this.panelIP)];
                        this.getS_airValue();
                    }
                });
            },
            getPanelDimensions() {
                this.isAeCalculated = false;
                this.panelDimension = '';
                this.paneldimensionslist = [];
                var tempIp = this.getIp();
                if (this.$store.state.panelTypeIndex == 1) {
                    if (this.getIp() == 31) {
                        tempIp = 55;
                    }
                }
                api.panels.getPanelDimensions(this.$store.state.panelTypeIndex, tempIp).then((res) => {
                    if (res.isError) {
                        console.log("error ");
                    } else {
                        res.data.forEach((e) => {
                            this.paneldimensionslist.push(e.Y + "x" + e.G + "x" + e.D);
                        });
                        this.panelDimension = this.$store.state.panelDimension;
                    }
                });
            },
            getS_airValue() {
                this.isAeCalculated = false;
                var ip = this.paneliplist.indexOf(this.panelIP);
                if (ip == -1) {
                    ip = 0;
                }
                ip += 1;
                this.ip_Id = ip;

                var width = 0;
                if (this.$store.state.panelDimension != null) {
                    const dimension = this.$store.state.panelDimension.split("x");
                    width = parseFloat(dimension[1]);
                }
                if (this.panelDimension != null && this.panelDimension != '') {
                    const dimension = this.panelDimension.split("x");
                    width = parseFloat(dimension[1]);
                }
                api.panels.getS_airValue(this.$store.state.ratedCurrentIndex, ip, width).then((res) => {
                    if (res != null) {
                        if (res.isError) {
                            console.log("error ");
                        } else {
                            this.Sair = res.data;
                        }
                    } else {
                        this.Sair = "N/A";
                    }
                });
            },
            getLocationVirtualSurfaceOptions() {
                this.virtualsurfaces = [];
                this.virtualsurfaceoptions = [];
                this.virtualsurfaceoptions.push(0);
                api.panels.getLocationVirtualSurfaceOptions(this.$store.state.panelTypeIndex, this.$lang.Format.Lang).then((res) => {
                    if (res != null) {
                        if (res.isError) {
                            console.log("error ");
                        } else {
                            res.data.forEach((e) => {
                                this.virtualsurfaces.push(e.PanelLocation);
                            });
                            this.virtualSurface = this.$store.state.virtualSurface;
                        }
                    } else {
                        this.virtualsurfaces.push(0);
                        this.virtualSurface = this.$store.state.virtualSurface;
                    }
                });
            },
            getLocationVirtualSurfaceOptions_2() {
                this.isAeCalculated = false;
                this.surfaceId = this.radios_surface.indexOf(this.virtualSurface);
                this.surfaceId += 1;

                if (this.$store.state.panelTypeIndex == 0) {
                    this.surfaceId_2 = this.radios_surface.indexOf(this.virtualSurface);
                    this.surfaceId_2 += 1;
                } else {
                    if (this.surfaceId < 4) {
                        this.surfaceId_2 = this.surfaceId * 2;
                    } else if (this.surfaceId == 4) {
                        this.surfaceId_2 = 7;
                    }
                }

                if (this.$store.state.ratedCurrentIndex == 1) {
                    this.virtualsurfaceoptions = [];
                    this.virtualsurfaceoptions.push(0);
                } else {
                    this.virtualsurfaceoptions = [];
                    api.panels.getLocationVirtualSurfaceOptions(this.$store.state.panelTypeIndex, this.$lang.Format.Lang).then((res) => {
                        if (res != null) {
                            if (res.isError) {
                                console.log("error ");
                            } else {
                                var index = this.radios_surface.indexOf(this.virtualSurface);
                                if (index == -1) {
                                    index = 0;
                                }
                                for (let i = 0; i < res.data[index].SurfaceOptions.length; i++) {
                                    this.virtualsurfaceoptions.push(res.data[index].SurfaceOptions[i]);
                                }
                            }
                        } else {
                            this.virtualsurfaceoptions = [];
                        }
                    });
                }
            },
            getHorizontalSeperationNumbers() {
                this.seperationnumbers = [];
                api.panels.getHorizontalSeperationNumbers(this.$store.state.ratedCurrentIndex).then((res) => {
                    if (res != null) {
                        if (res.isError) {
                            console.log("error ");
                        } else {
                            res.data.forEach((e) => {
                                this.seperationnumbers.push(e);
                            });
                            this.seperationNumber = this.$store.state.seperationNumber;
                        }
                    } else {
                        this.seperationnumbers.push(0);
                        this.seperationNumber = this.$store.state.seperationNumber;
                    }
                });
            },
            getAeValue() {
                this.ae_values = [];
                var panelTypeIndex = this.panelTypeRadioList.indexOf(this.panelTypeRadio);
                var surfaceLocationIndex = this.radios_surface.indexOf(this.virtualSurface);
                if (panelTypeIndex == 1) {
                    surfaceLocationIndex = (surfaceLocationIndex + 1) * 2;
                } else {
                    surfaceLocationIndex += 1;
                }
                return api.panels.getAeValue(this.$store.state.ratedCurrentIndex, surfaceLocationIndex, this.panelDimension).then((res) => {
                    if (res != null) {
                        if (res.isError) {
                            console.log("error ");
                        } else {
                            this.ae_values.push(res.data.UpSurface_AeValue);
                            this.ae_values.push(res.data.FrontSurface_AeValue);
                            this.ae_values.push(res.data.BackSurface_AeValue);
                            this.ae_values.push(res.data.LeftSurface_AeValue);
                            this.ae_values.push(res.data.RightSurface_AeValue);
                            this.total_Ae = 0;
                            for (let i = 0; i < this.ae_values.length; i++) {
                                this.total_Ae += this.ae_values[i];
                            }
                            this.total_Ae = this.setDecimalView(this.total_Ae, 3);

                            this.ae_value_field_up = this.setDecimalView(res.data.UpSurface_AeValue, 3);
                            this.ae_value_field_front = this.setDecimalView(res.data.FrontSurface_AeValue, 3);
                            this.ae_value_field_back = this.setDecimalView(res.data.BackSurface_AeValue, 3);
                            this.ae_value_field_left = this.setDecimalView(res.data.LeftSurface_AeValue, 3);
                            this.ae_value_field_right = this.setDecimalView(res.data.RightSurface_AeValue, 3);
                            this.total_Ae_field = this.total_Ae;

                            this.isAeCalculated = true;
                            return true;
                        }
                    } else {
                        this.ae_values.push(0);
                    }
                    this.$buefy.toast.open({ message: this.$lang.PanelInfos.AeLookupFailed, type: 'is-danger' });
                    return false;
                });
            },
            getAeValue_2() {
                this.ae_values = [];
                return api.panels.getAeValue(this.$store.state.ratedCurrentIndex, this.$store.state.virtualSurfaceIndex, this.$store.state.panelDimension).then((res) => {
                    if (res != null) {
                        if (res.isError) {
                            console.log("error ");
                        } else {
                            this.ae_values.push(res.data.UpSurface_AeValue);
                            this.ae_values.push(res.data.FrontSurface_AeValue);
                            this.ae_values.push(res.data.BackSurface_AeValue);
                            this.ae_values.push(res.data.LeftSurface_AeValue);
                            this.ae_values.push(res.data.RightSurface_AeValue);
                            this.total_Ae = 0;
                            for (let i = 0; i < this.ae_values.length; i++) {
                                this.total_Ae += this.ae_values[i];
                            }
                            this.total_Ae = this.setDecimalView(this.total_Ae, 3);

                            this.ae_value_field_up = this.setDecimalView(res.data.UpSurface_AeValue, 3);
                            this.ae_value_field_front = this.setDecimalView(res.data.FrontSurface_AeValue, 3);
                            this.ae_value_field_back = this.setDecimalView(res.data.BackSurface_AeValue, 3);
                            this.ae_value_field_left = this.setDecimalView(res.data.LeftSurface_AeValue, 3);
                            this.ae_value_field_right = this.setDecimalView(res.data.RightSurface_AeValue, 3);
                            this.total_Ae_field = this.total_Ae;

                            this.isAeCalculated = true;
                            return true;
                        }
                    } else {
                        this.ae_values.push(0);
                    }
                    this.$buefy.toast.open({ message: this.$lang.PanelInfos.AeLookupFailed, type: 'is-danger' });
                    return false;
                });
            },
            getAeValue_3() {
                this.controlInputs();
                if (this.canGoNextPage) {
                    this.getAeValue();
                }
            },
            openInfo() {
                if (!this.isInfoOpened) {
                    this.isInfoOpened = true;
                } else {
                    this.isInfoOpened = false;
                }
            },
            setDecimalView(numToBeTruncated, numOfDecimals) {
                var theNumber = numToBeTruncated.toString();
                var pointIndex = theNumber.indexOf('.');
                return +(theNumber.slice(0, pointIndex > -1 ? ++numOfDecimals + pointIndex : undefined));
            },
            setAeNotCalculated() {
                this.isAeCalculated = false;
            }
        },

    };
</script>

<style>
    .panelList1 {
        padding-left: 1.25rem;
        list-style-type: "-  ";
    }

    .panelList2 {
        padding-left: 1.25rem;
        list-style-type: "•  ";
    }
</style>
